var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"contentEl",class:_vm.disabled ? 'has-text-grey': '',attrs:{"name":_vm.name,"contenteditable":_vm.editable && !_vm.disabled,"placeholder":_vm.placeholder || _vm.$t('misc.content_editable_placeholder')},on:{"input":_vm.onInput,"focus":_vm.selectContent,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }